import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Link } from 'formlabs-web-components/Link';

import AddToCart from './AddToCart';
import Price from './Price';

import './Product.module.css';

const cdnUrl = `${
  process.env.RAZZLE_MAGENTO_MEDIA_URL
}/catalog/product/400x400`;

const Product = ({
  attributes,
  baseUrl,
  classes,
  imagePosition,
  name,
  price,
  sku,
  url
}) => {
  const { image, shortDescription } = attributes;
  const [t] = useTranslation();

  const to = `${baseUrl}${url}/`;

  return (
    <section
      className={classes}
      styleName={classnames('product', `image-${imagePosition}`)}
    >
      <div styleName="image">
        <Link to={to}>
          <img src={`${cdnUrl}${image}`} alt={name} />
        </Link>
      </div>
      <div styleName="body">
        <div styleName="name">
          <Link to={to}>{name}</Link>
        </div>
        <div
          styleName="description"
          dangerouslySetInnerHTML={{ __html: shortDescription }}
        />
        <Price styleName="price" price={price} />
        <div styleName="action">
          <AddToCart
            amount={1}
            name={name}
            sku={sku}
            title={t('Add to cart')}
          />
        </div>
      </div>
    </section>
  );
};

Product.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  imagePosition: PropTypes.oneOf(['left', 'right', 'top'])
};

Product.defaultProps = {
  imagePosition: 'left'
};

export default DisplayComponent(Product);
